
import BundleProductColorBlock from './bundle-product-color-block.vue'

export default {
  components: { BundleProductColorBlock },
  inject: ['wording'],
  props: {
    product: {
      type: Object,
      required: true,
    },
    defaultColor: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedColor: null,
    }
  },
  computed: {
    colors() {
      const productColors = this.product.colors

      // sort by default color first
      const sortedColors = productColors.sort((a, b) => {
        if (a.internal_color_code === this.defaultColor) return -1
        if (b.internal_color_code === this.defaultColor) return 1
        return 0
      })

      return sortedColors
        .sort((a, b) => {
          if (a.availability && !b.availability) return -1
          if (!a.availability && b.availability) return 1
          return 0
        })
        .filter((c) => c.availability)
    },
  },
  mounted() {
    this.selectedColor = this.colorFromInternalCode(
      this.product.internal_color_code
    )
  },
  methods: {
    colorFromInternalCode(colorCode) {
      return this.product.colors.find(
        (c) => c.internal_color_code === colorCode
      )
    },
    selectColor(color) {
      this.selectedColor = color
      this.$emit('colorSelect', color.internal_color_code)
    },
    getColorAvailability(color) {
      return !color.availability
    },
    getSelectedSizeAvailability(color) {
      if (this.productOverloaded) return !color.availability

      if (this.selectedSize && this.selectedSize.name) {
        return !color.availableSizes?.includes(this.selectedSize.name)
      } else {
        return !color.availability
      }
    },
  },
}
